import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";

import moment from "moment";
import "react-dates/initialize";
import 'react-dates/lib/css/_datepicker.css';

import { DayPickerRangeController, DateRangePicker, isInclusivelyBeforeDay } from "react-dates";

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Mousewheel } from "swiper";

import { TooltipCustom } from "../../components/tooltip";

import { commonErr } from "../../common/errors";
import { formatTime, getBookingTimes, isEmptyObj} from "../../common/common"
import {START_DATE, HORIZONTAL_ORIENTATION } from "../../../constant/constant" 



import { IcNextCircle } from "../../common/svg"

const bookingTimes = getBookingTimes();


class Calendar extends React.Component { 

	constructor(props) {
		super(props)
		this.state = {

			focusedInput: null,
			// swiperST: null,
			// swiperET: null,
			isDropdownST: false,
			isDropdownET: false,
			errDate: ""

		}
		this.wrapperST = React.createRef();
		this.wrapperET = React.createRef();
	}

	componentDidMount() {

		this.setState({
			startDate: this.props.startDate,
			endDate: this.props.endDate,
			startTime: this.props.startTime,
			endTime: this.props.endTime
		})

		if (this.props.appInit.err === commonErr.SUCCESS && this.props.appInit.data) { 
			this.setState({
				minDate: this.props.appInit.data.startDate,
				maxDate: this.props.appInit.data.endDate
			})
		}
		
		document.addEventListener("click", this.handleClick);
	
	}

	componentDidUpdate(props) {
		if (this.state.isDropdownST) {
			if (document.getElementById(`ast${this.state.startTime}`) !== null) {
				const target = document.getElementById(`ast${this.state.startTime}`);
				target.scrollIntoView({ behavior: "smooth" });
			}
		}
		if (this.state.isDropdownET && this.state.endTime >= 0) {
			if (document.getElementById(`aet${this.state.endTime}`) !== null) {
				const targetET = document.getElementById(`aet${this.state.endTime}`);
				targetET.scrollIntoView({ behavior: "smooth" });
			}
		}
		if (props.appInit.err !== this.props.appInit.err) {
			if (this.props.appInit.err === commonErr.SUCCESS && this.props.appInit.data) { 
				this.setState({
					minDate: this.props.appInit.data.startDate,
					maxDate: this.props.appInit.data.endDate
				})
			}
		}
	}



	handleClick = (event) => {

		const { target } = event;

		
		if (target !== null && this.wrapperST.current !== null && !this.wrapperST.current.contains(target)) {

			const { isDropdownST } = this.state;
		
			if (isDropdownST) {
				this.setState({
					isDropdownST: false,
				});
			}
		}

		if (target !== null && this.wrapperET.current !== null && !this.wrapperET.current.contains(target)) {

			const { isDropdownET } = this.state;
		
			if (isDropdownET) {
				this.setState({
					isDropdownET: false,
				});
			}
		}
		
	};

	onHandleDropdown = (name) => {
		this.setState({
			[`${name}`]: true,
		});
	}

	onCloseDropdown = (name) => {
		this.setState({
			[`${name}`]: false,
		});
	}

	onStartTimeChange = (e) => {
			let startTime = e.target.value;
			const { endDate, endTime } = this.state;
			const hour = (startTime - (startTime % 60)) / 60;
			const min = startTime % 60;

			var startDate = moment(
				this.state.startDate 
			).set({
				hour: hour,
				minute: min,
				second: 0,
				milliseconds: 0,
			});


			this.checkValidDate(startDate, endDate, startTime, endTime)

			this.setState({
				startTime: startTime,
				startDate: startDate
			})

			this.props.onStartTimeChange(startTime)

			this.onCloseDropdown("isDropdownST")


 		
	}

	
	onEndTimeChange = (e) => {
			const { startDate, startTime } = this.state;
			let endTime = e.target.value 
		
			const hour = (endTime - (endTime % 60)) / 60;
			const min = endTime % 60;

			if (this.state.endDate) {
				var endDate = moment(
					this.state.endDate 
				).set({
					hour: hour,
					minute: min,
					second: 0,
					milliseconds: 0,
				});
				
				this.checkValidDate(startDate, endDate, startTime, endTime)
			}


			this.setState({
				endTime: endTime,
				endDate: endDate
			})

		
			this.props.onEndTimeChange(endTime)
			this.onCloseDropdown("isDropdownET")
		

 	
	}
	  

    onDatesChange = (dates) => {

		let {startDate, endDate} = dates
		const { startTime, endTime } = this.state;
		
		if (startDate && endDate) {

			startDate = moment(dates.startDate).set({
				hour: (startTime - startTime % 60) / 60,
				minute: startTime % 60,
				second: 0
					});
	
			endDate = moment(dates.endDate).set({
				hour: (endTime - endTime % 60) / 60,
				minute: endTime % 60,
				second: 0
			});
	
			this.checkValidDate(startDate, endDate, startTime, endTime)

			// if (endDate.valueOf() === startDate.valueOf() && endTime <= startTime) {
			// 	this.setState({
			// 		errDate: 'Thời gian nhận xe phải trước giờ trả xe ít nhất 1 tiếng khi thuê trong ngày'
			// 	})
			// }

			// if (startDate.valueOf() > endDate.valueOf()) {
			// 	this.setState({
			// 		errDate: 'Thời gian trả xe phải lớn hơn thời gian nhận xe'
			// 	})
			// }

			// if (startDate.valueOf() < endDate.valueOf()) {
			// 	this.setState({
			// 		errDate: ''
			// 	})
			// }

		}

			this.props.onDatesChange(dates)
			this.setState({
				startDate: startDate,
				endDate: endDate
			})
		}


		
		checkValidDate = (startDate, endDate, startTime, endTime) => {
			let cstartTime = Number(startTime)
			let cendTime = Number(endTime)
			const hour = (cendTime - cstartTime)/60
			const isSameDay = endDate.format('DD/MM/YYYY') === startDate.format('DD/MM/YYYY');
	
			if ((isSameDay && cendTime === cstartTime) || (isSameDay && ( 0 < hour && hour < 2))) {
				this.setState({
					errDate: 'Thời gian kết thúc phải lớn hơn thời gian bắt đầu 2 tiếng'
				})
			} else if ((!isSameDay && startDate.valueOf() > endDate.valueOf()) || (isSameDay && cendTime < cstartTime) ) {
				this.setState({
					errDate: 'Thời gian trả xe phải lớn hơn thời gian nhận xe'
				})
			} else {
				this.setState({
					errDate: ''
				})
			}
		}

     renderAvailDayContents = (day) => {
        
        return (
          <span className="holiday-dates" >
            {moment(day).format("D")}
          </span>
        );
      };
    
	onFocusChange = (focusedInput) => {
		this.setState({
			// Force the focusedInput to always be truthy so that dates are always selectable
			focusedInput: (!focusedInput) ? START_DATE : focusedInput,
		  });
	}

	isOutsideRange = (day) => {
		const { minDate, maxDate } = this.state;
		return  day.isAfter(moment(maxDate).add(1, 'days')) || day.isBefore(moment(minDate).subtract(1, 'days'));
	}


    closeBox = () => {
        this.props.hideModal()
    }

	searchCar = () => {
		const { filter } = this.props;
		this.props.searchCar(filter);
		this.props.hideModal()
	}

	getDayChildContent = (day) => {
		const obj = this.props.getDayChildContent(day)
	
		return <>
				{obj && obj.unavail ? obj.unavail() : null}
				{obj && obj.child ? obj.child() : null}
				{obj && obj.instant ? obj.instant() : null}
				{obj && obj.booking ? obj.booking() : null}
			</>
		
		
	}

	countDayRent = (startDate, endDate) => {
		if(startDate.format('DD/MM/YYYY') === endDate.format('DD/MM/YYYY')) {
			return "1"
		}
		return Math.ceil(endDate.diff(startDate, 'seconds') / 86400)
	}

	tooltRentTitle = () => {
		const {startDate, endDate} = this.state;
		return (
			<>
				Số ngày thuê:{" "} <span className="fontWeight-6" style={{margin: '0 2px'}}>{this.countDayRent(startDate, endDate)}</span> ngày

			</>
		);
	}
	tooltRent = () => {
		return (
			<>
				Giá thuê xe được tính theo ngày. Nếu bạn thuê xe dưới 24h sẽ được tính tròn 1 ngày
			</>
		);
	}


    render() {
        const { show, finding, pickupTimesStr, returnTimesStr, minTimesRepeatDetected, minTimesDetected, isMCalendar, isValidPickupReturnTimes, errMsg, errBooking }  = this.props; 
		const { endDate, startDate, startTime, endTime, isDropdownST, isDropdownET, errDate, minDate, maxDate} = this.state;

		let msgReturnPickup = this.props.msgReturnPickup()

		const errorDate =
		!isEmptyObj(minTimesDetected) ||
		minTimesRepeatDetected !== "" ||
		(minTimesRepeatDetected && minTimesRepeatDetected !== "") || errBooking !== "" || errDate !== "" ||
		errMsg !== "";

		const isValid = errDate === "" && startDate && endDate && isValidPickupReturnTimes

		const defaultProps = {

			initialStartDate: moment(),
			initialEndDate: moment().add(1, "days"),

			// day presentation and interaction related props
		
			isDayBlocked: () => false,
			isDayHighlighted: () => false,
			enableOutsideDays: false,
			daysViolatingMinNightsCanBeClicked: false,
		  
			// calendar presentation and interaction related props
			orientation: HORIZONTAL_ORIENTATION,
			verticalHeight: undefined,
			withPortal: false,
		
			numberOfMonths: 2,
			onOutsideClick() {},
			keepOpenOnDateSelect: false,
		
			isRTL: false,
			renderMonthText: null,
			renderMonthElement: null,
			renderKeyboardShortcutsButton: undefined,
			renderKeyboardShortcutsPanel: undefined,
		  
			// navigation related props
			navPrev: null,
			navNext: null,
			renderNavPrevButton: null,
			renderNavNextButton: null,
		
		  
			// internationalization
			monthFormat: 'MMMM YYYY',
		}

        return (
				<Modal
					show={show}
					onHide={this.closeBox}
					dialogClassName="modal-m modal-dialog modal-fix modal-search has-footer">
					<Modal.Header closeButton={true} closeLabel={""}>
							<h5>Thời gian</h5>
					</Modal.Header>
					<Modal.Body>
						<div className="modal-confirm-body">

							{!isMCalendar ? 
							<DayPickerRangeController 
								{...defaultProps}
								minDate={moment(minDate)}
								maxDate={moment(maxDate)}
								onDatesChange={(dates) => { this.onDatesChange(dates)}}
								focusedInput={this.state.focusedInput || START_DATE} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
								onFocusChange={(focusedInput) => this.onFocusChange(focusedInput)}
								startDate={startDate}
								endDate={endDate}
								//   renderCalendarInfo={renderCalendarInfo}
								onPrevMonthClick={() => {}}
								onNextMonthClick={(month) => {console.log(month)}}
								numberOfMonths={2}
								enableOutsideDays={false}
								isOutsideRange={this.isOutsideRange}
								hideKeyboardShortcutsPanel={true}
								minimumNights={0}
								monthFormat="MMMM"
								initialVisibleMonth={() => moment()}
								renderDayContents={(day) => <p>{day.format('D')} {this.getDayChildContent(day)}</p>}

							/> : <div style={{height: '320px'}} >
							<DayPickerRangeController 
								{...defaultProps}
								minDate={moment(minDate)}
								maxDate={moment(maxDate)}
								onDatesChange={(dates) => { this.onDatesChange(dates)}}
								focusedInput={this.state.focusedInput || START_DATE} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
								onFocusChange={(focusedInput) => this.onFocusChange(focusedInput)}
								startDate={startDate}
								endDate={endDate}
								minimumNights={0}
								noNavButtons={true}
								//   renderCalendarInfo={renderCalendarInfo}
								onPrevMonthClick={() => {}}
								onNextMonthClick={(month) => {console.log(month)}}
								hideKeyboardShortcutsPanel={true}
								enableOutsideDays={false}
								isOutsideRange={this.isOutsideRange}
								orientation="verticalScrollable"
								numberOfMonths={3}
								verticalHeight={600}
								monthFormat="MMMM"
								renderDayContents={(day) => <p>{day.format('D')} {this.getDayChildContent(day)}</p>}
								initialVisibleMonth={() => moment()} />
							</div>}
						</div>
						<div className={`time-choose ${(isEmptyObj(minTimesDetected) && minTimesRepeatDetected === "" && pickupTimesStr === "" &&  returnTimesStr === "" && errDate === "" && errBooking === "") ? 'bottom' : ''}`}>
								<div className="time-choose__item" ref={this.wrapperST}>
									<div onClick={() => isDropdownST ? this.onCloseDropdown('isDropdownST') : this.onHandleDropdown('isDropdownST')}>
										<p className="title-time">Giờ nhận xe</p>
										<p className="active-time">{formatTime(startTime)}</p>
									</div>
									{isDropdownST && <div className="dropdown-time"> 
										{bookingTimes.map(time => <div className="custom-radio" id={`ast${time.value}`} key={`ra${time.id}`}> 
											<input type="radio" id={`rst${time.id}`} name={`r-startTime`} value={time.value} checked={startTime == time.value} onChange={this.onStartTimeChange}/>
											<label htmlFor={`rst${time.id}`}>{time.label}</label>
										</div>)}
									</div>}
								</div>
								<div className="wrap-svg">
									<IcNextCircle /> 
								</div>
								<div className="time-choose__item" ref={this.wrapperET}>
									<div onClick={() => isDropdownET ? this.onCloseDropdown('isDropdownET') : this.onHandleDropdown('isDropdownET')}>
										<p className="title-time">Giờ trả xe </p>
										<p className="active-time">{formatTime(endTime)}</p>
									</div>
									{isDropdownET && <div className="dropdown-time">
										{bookingTimes.map(time => <div className="custom-radio" id={`aet${time.value}`} key={`re${time.id}`}> 
											<input type="radio" id={`ret${time.id}`} name={`r-endTime`} value={time.value} checked={endTime == time.value} onChange={this.onEndTimeChange}/>
											<label htmlFor={`ret${time.id}`}>{time.label}</label>
										</div>)}
										
									</div>}
								</div>
							
							</div>

							{!(isEmptyObj(minTimesDetected) && minTimesRepeatDetected === "") && <div style={errDate === "" ? {marginBottom: '0px'} : null}>
								
								{!isEmptyObj(minTimesDetected)
								? <p class="font-12 text-danger">* Thời gian thuê tối thiểu từ {minTimesDetected.s.format("DD/MM/YYYY")} đến {minTimesDetected.e.format("DD/MM/YYYY")} là {
										minTimesDetected.dayNumbers % 1 > 0
											? minTimesDetected.dayNumbers - (minTimesDetected.dayNumbers % 1) + 1
											: minTimesDetected.dayNumbers
									} ngày</p>
							: ""}
								{minTimesRepeatDetected !== ""
										? <p class="font-12 text-danger" >* {minTimesRepeatDetected}</p>
										: ""
								}</div>}


							{errDate !== "" && <div className="text-danger">
								<p className="font-12">* {errDate}</p>
							</div>}

							{errBooking !== "" && <div className="text-danger">
								<p className="font-12">* {errBooking}</p>
							</div>}

							{errMsg !== "" && !(!isEmptyObj(minTimesDetected) || minTimesRepeatDetected !== "" || !isValidPickupReturnTimes || errBooking !== "") && <div className="text-danger">
								<p className="font-12">* {errMsg}</p>
							</div>}


							{(returnTimesStr || pickupTimesStr) ? <div className={`time-avail ${!isValidPickupReturnTimes ? "" :"marginBottom-l"}`}>
								{pickupTimesStr !== "" && <div className="time-avail__item">
									<p>Thời gian nhận xe</p>
									<p>{pickupTimesStr}</p>
								</div>}
								{returnTimesStr !== "" && <div className="time-avail__item">
									<p>Thời gian trả xe</p>
									<p>{returnTimesStr}</p>
								</div>}
							</div> : null}

							{!isValidPickupReturnTimes && (
								<div className="text-danger">
									<p className="font-12">Xe chỉ hỗ trợ {msgReturnPickup}. Vui lòng điều chỉnh lại giờ nhận trả xe thích hợp</p>
								</div>
							)}

							
						
					</Modal.Body>
						<Modal.Footer>
							<div className="info-time"> 
							<div className="info-time__item">
								{/* <p className="time">{startTime ? `${formatTime(startTime)}` : null} {startDate ? startDate.format('DD/MM') : "Chọn ngày bắt đầu"} - {endTime ? `${formatTime(endTime)}` : null} {endDate ? endDate.format('DD/MM') : "Chọn ngày kết thúc"} </p> */}
								<p className="time">{startTime >= 0 && startDate ? `${formatTime(startTime)}, ${startDate.format('DD/MM')}` : <span className="text-disabled">Chọn ngày bắt đầu</span>} - {endTime >= 0 && endDate ? `${formatTime(endTime)}, ${endDate.format('DD/MM')}` : <span className="text-disabled">Chọn ngày kết thúc</span>} </p>

								{startDate && endDate ? <TooltipCustom clgTitle={'total'} title={this.tooltRentTitle} desc={this.tooltRent} />  : null}
							</div>
							<div className="wrap-btn"><a disabled={!isValid} className="btn btn--s btn-primary" onClick={this.closeBox} >Tiếp tục</a></div>
							</div>
						</Modal.Footer>
					</Modal>
					)
				}
}

function mapState(state) {
	return {
		appInit: state.appInit
	};
}

Calendar = connect(mapState)(Calendar);

export default Calendar 


{/* <div className="time-picker">
				<div className="time-picker__item"> 
					<h6>Nhận xe</h6>
                        {startTime && <Swiper
							modules={[FreeMode, Navigation, Mousewheel]}
							direction={'vertical'}
							mousewheel={{
								sensitivity: 0.5,
							}}
							slidesPerView={3}
							freeMode={{
								sticky: true,
								minimumVelocity: 0.1,
								momentumRatio: 0.25,
								momentumVelocityRatio: 0.25,
							}}
							centeredSlides={true}
							onSlideChange={() => this.onStartTimeChange()}
							slideToClickedSlide={true}
							onSwiper={(swiper) => { this.setState({swiperST: swiper}); this.slideToStartTime(swiper)}}
							className={`swiper-time-picker`}>

						{bookingTimes.map(time => <SwiperSlide>
							{time.label}
						</SwiperSlide>)}
					</Swiper>}
				
					
				</div>
				<div className="time-picker__item">
					<h6>Trả xe</h6>

					{endTime && <Swiper
							modules={[FreeMode, Navigation, Mousewheel]}
					
							direction={'vertical'}
							mousewheel={{
								sensitivity: 0.5,
							}}
							slidesPerView={3}
							freeMode={{
								sticky: true,
								minimumVelocity: 0.1,
								momentumRatio: 0.25,
								momentumVelocityRatio: 0.25,
							}}
							centeredSlides={true}
							onSlideChange={() => this.onEndTimeChange()}
							slideToClickedSlide={true}
							onSwiper={(swiper) => { this.setState({swiperET: swiper}); this.slideToEndTime(swiper)}}
							className={`swiper-time-picker`}>

						{bookingTimes.map(time => <SwiperSlide>
							{time.label}
						</SwiperSlide>)}
					</Swiper>}
				</div>
			</div> */}